import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link"]

  select(event) {
    this.linkTargets.forEach(el => el.classList.remove("active"))
    event.currentTarget.classList.add("active")
  }
}
